/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * デフォルトの検索条件
 * @export
 * @interface ArticlePastSearchDefaultCondition
 */
export interface ArticlePastSearchDefaultCondition {
    /**
     * 過去記事検索の期間指定開始日の最小値 (From 無料: 1ヶ月前, 有料: 1年前)
     * @type {string}
     * @memberof ArticlePastSearchDefaultCondition
     */
    minStartDate: string;
    /**
     * 過去記事検索の期間指定終了日の最大値 (To 本日)
     * @type {string}
     * @memberof ArticlePastSearchDefaultCondition
     */
    maxEndDate: string;
    /**
     * 過去記事検索のデフォルト期間指定 (From 1ヶ月前)
     * @type {string}
     * @memberof ArticlePastSearchDefaultCondition
     */
    defaultStartDate: string;
    /**
     * 過去記事検索のデフォルト期間指定 (To 本日)
     * @type {string}
     * @memberof ArticlePastSearchDefaultCondition
     */
    defaultEndDate: string;
}

export function ArticlePastSearchDefaultConditionFromJSON(json: any): ArticlePastSearchDefaultCondition {
    return ArticlePastSearchDefaultConditionFromJSONTyped(json, false);
}

export function ArticlePastSearchDefaultConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArticlePastSearchDefaultCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'minStartDate': json['min_start_date'],
        'maxEndDate': json['max_end_date'],
        'defaultStartDate': json['default_start_date'],
        'defaultEndDate': json['default_end_date'],
    };
}

export function ArticlePastSearchDefaultConditionToJSON(value?: ArticlePastSearchDefaultCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'min_start_date': value.minStartDate,
        'max_end_date': value.maxEndDate,
        'default_start_date': value.defaultStartDate,
        'default_end_date': value.defaultEndDate,
    };
}

